import { Bookmark, Share2 } from "lucide-react";
import { toast } from "sonner";
import { remainingLabel } from "@/lib/blog/text";

function Ring({ progress }: { progress: number }) {
  const r = 9;
  const c = 2 * Math.PI * r;
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" aria-hidden className="-rotate-90">
      <circle cx="11" cy="11" r={r} fill="none" stroke="var(--hairline-default)" strokeWidth="2.5" />
      <circle
        cx="11"
        cy="11"
        r={r}
        fill="none"
        stroke="var(--amber-600)"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeDasharray={c}
        strokeDashoffset={c * (1 - progress)}
      />
    </svg>
  );
}

export function ArticleActions({
  readingMin,
  progress,
  saved,
  onToggleSave,
  title,
}: {
  readingMin: number | null;
  progress: number;
  saved: boolean;
  onToggleSave: () => void;
  title: string;
}) {
  const share = async () => {
    const url = window.location.href;
    if (navigator.share) {
      try {
        await navigator.share({ title, url });
        return;
      } catch (e) {
        if ((e as Error)?.name === "AbortError") return;
      }
    }
    try {
      await navigator.clipboard.writeText(url);
      toast("تم نسخ الرابط");
    } catch {
      toast.error("ما زبط نسخ الرابط");
    }
  };
  const pct = Math.round(progress * 100);
  return (
    <div className="flex shrink-0 items-center gap-1 min-[400px]:gap-1.5">
      <div
        role="progressbar"
        aria-label="موضع القراءة"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={pct}
        className="hidden h-10 items-center gap-1.5 rounded-ds-pill border border-hairline-default bg-surface px-2 font-display text-[13px] min-[400px]:px-2.5 font-bold text-brown-700 min-[360px]:inline-flex"
      >
        <Ring progress={progress} />
        <span className="whitespace-nowrap">{remainingLabel(readingMin, progress)}</span>
      </div>
      <button
        type="button"
        aria-pressed={saved}
        aria-label={saved ? "محفوظ" : "حفظ"}
        onClick={onToggleSave}
        className={`inline-flex h-12 min-w-12 items-center justify-center gap-1 rounded-ds-pill border px-3 font-display text-[14px] font-bold transition-colors duration-ds-fast ${
          saved ? "border-amber-600 bg-amber-100 text-amber-800" : "border-hairline-default bg-surface text-brown-700 hover:bg-cream-100"
        }`}
      >
        <Bookmark className="h-4 w-4" strokeWidth={1.75} fill={saved ? "currentColor" : "none"} aria-hidden />
        <span className="hidden min-[400px]:inline">{saved ? "محفوظ" : "حفظ"}</span>
      </button>
      <button
        type="button"
        aria-label="مشاركة"
        onClick={share}
        className="grid h-12 w-12 place-items-center rounded-full border border-hairline-default bg-surface text-brown-700 transition-colors duration-ds-fast hover:bg-cream-100"
      >
        <Share2 className="h-5 w-5" strokeWidth={1.75} aria-hidden />
      </button>
    </div>
  );
}
